import React from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import {
	ErrorType,
	Severity,
	Product,
	Team,
	createProductSpecificAnalyticsIntegrationPayload,
} from '@atlassian/growth-commons-error-analytics';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { TransparentErrorBoundary } from '@confluence/error-boundary/entry-points/TransparentErrorBoundary.ts';

import { useIsEligibleForPremiumTrialEot } from '../../hooks/premium-trial-eot-graphql-query/useIsEligibleForPremiumTrialEot.ts';
import { showModalBasedOnLastDisplayTime } from '../../utils/modalDisplayUtils.ts';

import { RecommendStandardModal } from './RecommendStandardModal.tsx';

const EndOfTrialModalContainer = () => {
	const { hasEligibleTrial, loading, error, trialEndDate, trialDaysLeft } =
		useIsEligibleForPremiumTrialEot();

	if (loading || error || !trialEndDate || !trialDaysLeft) return null;

	if (!showModalBasedOnLastDisplayTime(trialEndDate, trialDaysLeft)) {
		return null;
	}

	if (hasEligibleTrial) {
		return <RecommendStandardModal trialEndDate={trialEndDate} />;
	}
};

export function EndOfTrialModalContainerWithErrorBoundary() {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	return (
		<TransparentErrorBoundary
			attribution={Attribution.GROWTH_LUNA}
			onError={(error: Error, info: React.ErrorInfo) => {
				const eventPayload = createProductSpecificAnalyticsIntegrationPayload({
					product: Product.CONFLUENCE,
					team: Team.GROWTH_LUNA,
					experimentMeta: {
						experimentKey: 'twcg-530_confluence_ai_in_editor_eot',
					},
					errorMessage: error.message,
					errorType: ErrorType.ERROR_BOUNDARY,
					severity: Severity.MEDIUM,
					source: 'EndOfTrialModalContainer',
					additionalAttributes: {
						...info,
					},
				});

				createAnalyticsEvent(eventPayload).fire();
			}}
		>
			<EndOfTrialModalContainer />
		</TransparentErrorBoundary>
	);
}
